import { useQuery } from '@tanstack/react-query'
import { useServices } from '../ServiceContext'
import { workflowGroups } from '../../auth/workflowGroups'

// ─── Query keys ───────────────────────────────────────────────────────────────

export const adminKeys = {
  groupMembers: (group: string) => ['admin', 'group-members', group] as const,
}

// ─── Queries ──────────────────────────────────────────────────────────────────

export function useGroupMembers(group: string) {
  const { adminService } = useServices()
  return useQuery({
    queryKey: adminKeys.groupMembers(group),
    queryFn: () => adminService.getGroupMembers(group),
    enabled: Boolean(group),
  })
}

// ─── Per-role convenience hooks ───────────────────────────────────────────────

export const useQualityControlMembers  = () => useGroupMembers(workflowGroups.qualityControl)
export const useLayoutAndDesignMembers = () => useGroupMembers(workflowGroups.layoutAndDesign)
export const useEditorialManagers      = () => useGroupMembers(workflowGroups.editorialManager)
export const usePostProductionMembers  = () => useGroupMembers(workflowGroups.postProduction)
